import Toaster from "@meforma/vue-toaster";

const DeduplicatingToaster = {
    install(app, options) {
        // Install the original toaster
        app.use(Toaster, options);

        // Keep track of active toasts
        const activeToasts = new Set();

        // Get the original $toast object that was just injected
        const originalToast = app.config.globalProperties.$toast;

        // Save the original show method before overriding.
        // error/success/info/warning all delegate to show() internally, so
        // wrapping only show() is enough — wrapping the others too would cause
        // the message to already be in activeToasts when show() is reached,
        // making every toast appear to be a duplicate and never render.
        const originalShow = originalToast.show.bind(originalToast);

        app.config.globalProperties.$toast.show = (message, toastOptions) => {
            if (activeToasts.has(message)) {
                return;
            }

            activeToasts.add(message);

            const duration = (toastOptions && toastOptions.duration) || (options && options.duration) || 4000;
            setTimeout(() => {
                activeToasts.delete(message);
            }, duration);

            return originalShow(message, toastOptions);
        };
    }
};

export default DeduplicatingToaster;